<template>
  <v-snackbar :color="color" v-model="open" >
    {{ message }}
    <!-- <template v-slot:action="{ attrs }">
      <v-btn dark text v-bind="attrs" @click="open = false">Close</v-btn>
    </template>-->
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      color: "success",
      message: "",
    };
  },
  methods: {
    show(msgArray, type) {
      this.color = type;
      this.message = msgArray.toString();
      this.open = true;
    },
  },
};
</script>